import { Injectable, Injector } from '@angular/core';
import {
	HttpRequest,
	HttpHandler,
	HttpEvent,
	HttpInterceptor,
	HttpResponse
	} from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import {
	get as _get
} from 'lodash';

import { AppService } from '@app-services/app.service';


@Injectable()
export class TokenInterceptor implements HttpInterceptor {
	constructor(
		private _injector: Injector,
		private _appService: AppService,
	) {}

	intercept(
		request: HttpRequest<any>,
		next: HttpHandler,
	): Observable<HttpEvent<any>> {
		const params = request.params;
		request = request.clone({
			setHeaders: {
				// 'Content-Type': 'application/json; charset=utf-8',
				Authorization: 'Bearer ' + this._appService.accessToken,
			},
			setParams: {
				...params,
				language: _get(this._appService.currentLanguage + '', 'id') || '',
			},
		});
		return next.handle(request)
			.pipe(
			tap(
				event => {},
				error => {
					if (error && error.hasOwnProperty('error') && error.error.hasOwnProperty('error')) {
						// TOO MANY error! Please use something unique!
						const jsonResponse = error.error.error;
						let errorMsg = '';
						if (jsonResponse.hasOwnProperty('error')) {
							// And there's another one! Aaaaaaa!!!!!
							errorMsg = jsonResponse.error;
						}
						if (errorMsg === 'Invalid Token b' || errorMsg === 'Invalid Token' || errorMsg === 'Invalid Token '
							|| errorMsg === 'Token Expired' || errorMsg === 'Invalid User' || errorMsg === 'Invalid Token a'
						) {
							// TODO: Refactor this into calling the logout event
							localStorage.removeItem('access_token');
							localStorage.removeItem('refresh_token');
							localStorage.removeItem('user');
							localStorage.removeItem('language');
							localStorage.removeItem('crm_translation');
							localStorage.removeItem('translationLanguage');
							location.reload();
						}
					}
					console.log('HTTP Error:', error);
				}
			),
		);
	}
}
